import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import Modal from 'react-modal';
import { topicListFetch } from '../../../../actions/index';
import { ProfileThumb } from '../';
import { Icon } from '../../Icon';
import Loader from '../../Loader';
import { mobileCheck, gtmSend } from '../../../../helpers';
import NotificationSystem from 'react-notification-system';
import cx from '../../../../styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectTopic from '../../SelectTopic';
import EmbedLink from '../../EmbedLink';
import FetchGIF from '../../FetchGIF';
import SimilarQuestions from '../../SimilarQuestions';
import Hashtags from '../../Hashtags';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if (typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

class GenericInputModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false,
            anonymous: 0,
            ifShowAllTopics: false,
            groupId: '',
            mobileTitle: '',
            isShowNotification: true,
            isShowNotificationMessage: true,
            isClickSubmit: false,
            isNSFWChecked: 0,
            openTooltip: false,
            opnePreviewSection: false,
            showEmbed: false,
            showGIF: false,
            gif_id: '',
            gif_url: '',
            groupName: '',
            groupImage: '',
            showHashtag: false,
            loading: false,
            showSimilarQues: false,
            resize: true
        };
        this._notificationSystem = null;
    }

    componentDidMount() {
        if (this.state.isShowNotification) {
            if (this.props.eventHandlers.refAddNotification) this.props.eventHandlers.refAddNotification(this._addNotification);
        }
        if (this.state.isShowNotificationMessage) {
            if (this.props.eventHandlers.refAddNotificationMessage) this.props.eventHandlers.refAddNotificationMessage(this._addNotificationMessage);
        }
        //mobile title
        const mobileTitle = this.props.mobileTitle || '';
        this.setState({ mobileTitle, isModalOpen: this.props.isModalOpen });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.isModalOpen !== this.props.isModalOpen && !this.props.isModalOpen) {
            this.setState({ isClickSubmit: false }); // to stop page refresh on every alternate edit
        }
        if ((prevProps.imagePreviews !== this.props.imagePreviews && this.props.imagePreviews.length !== 0) || (prevProps.linkPreview !== this.props.linkPreview && this.props.linkPreview.url) || (prevState.gif_url !== this.state.gif_url && this.state.gif_url.length > 0)) {
            this.openPreview('upload')
        }
    }

    componentWillReceiveProps(nextProps) {
        // if(nextProps.isModalOpen != this.props.isModalOpen) {
        //     if(!nextProps.isModalOpen) {
        //         this.onRequestClose();
        //     } else {
        //         console.log('here1');
        //         this.setState({isModalOpen: true});
        //     }            
        // }
        //

        if (nextProps.switchState) {
            this.setState({ mobileTitle: this.props.t('select_a_topic') });
        }

        if (nextProps.isNSFWChecked && this.state.isNSFWChecked !== nextProps.isNSFWChecked) {
            this.setState({ isNSFWChecked: nextProps.isNSFWChecked });
        }

        if(nextProps.gif_id) {
            this.setState({gif_id : nextProps.gif_id})
        }

        if(nextProps.gif_url) {
            this.setState({gif_url : nextProps.gif_url})
        }

        if(nextProps.anonymous) {
            this.setState({anonymous : nextProps.anonymous})
        }

        if(nextProps.groupId && nextProps.groupName && nextProps.groupImage) {
            this.setState(
                { 
                    groupId : nextProps.groupId,
                    groupName : nextProps.groupName,
                    groupImage : nextProps.groupImage

                }
            )
        }

    }

    _addNotification = (message, level) => {
        if (this.state.isShowNotification) {
            this.setState({ isShowNotification: false });
            this._notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 3,
                position: 'tc'
            });
            setTimeout(() => {
                this.setState({ isShowNotification: true });
            }, 3000);
        }
    }

    // created new for different autoDismiss time
    _addNotificationMessage = (message, level) => {
        if (this.state.isShowNotificationMessage) {
            this.setState({ isShowNotificationMessage: false });
            this._notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 10,
                position: 'tc'
            });
            setTimeout(() => {
                this.setState({ isShowNotificationMessage: true });
            }, 10000);
        }
    }

    resetState = () => {
        this.setState({ anonymous: 0, ifShowAllTopics: false, groupId: '', mobileTitle: (this.props.mobileTitle ? this.props.mobileTitle : ''), isNSFWChecked: 0, opnePreviewSection: false, gif_id: '', gif_url: '', showHashtag: false });
    }

    selectTopic = () => {
        if (this.props.groupId > 0) {
            this.setState({ groupId: this.props.groupId })
        }
        if (document.getElementById('active-filter')) {
            const activeGroup = document.getElementById('active-filter');
            if (activeGroup && activeGroup.classList && activeGroup.classList[1] > '0') {
                this.setState({ groupName: activeGroup.childNodes[1].innerHTML, groupImage: activeGroup.childNodes[0].src });
            } else {
                if(!this.props.groupId) this.topicListData();
            }
        } else if (this.props.topic) {
            this.setState({ groupName: this.props.topic.name, groupImage: this.props.topic.image, groupId: this.props.topic.id });
        } else {
            if(!this.props.groupId) this.topicListData()
        }
    }

    topicListData = () => {
        this.setState({ loading: true })
        this.props.topicListFetch(1)
            .then(async (data) => {
                if (data.response && data.response.groups) {
                    this.setState({ groupId: data.response.groups[0].id, groupName: data.response.groups[0].name, groupImage: data.response.groups[0].image })
                }
                this.setState({ loading: false })
            })
            .catch((err) => {
                console.log("We have err after topic api call", err);
                this.setState({ loading: false })
            })
    }

    onAfterOpen = () => {
        this.props.gtmLabel === 'Compose' && gtmSend('post_compose', 'Post', 'Compose', '--', 0, { action: '--' });
        this.resetState();
        this.readPostFromDb();
        if (this.props.eventHandlers.onModalOpen) this.props.eventHandlers.onModalOpen();
        this.adjustDesc();
        this.editGifData();
        this.checkAttachments();
    }

    editGifData = () => {
        if (this.props.gifPreview && this.props.gifPreview[0]) {
            this.setState({ gif_id: this.props.gifPreview[0].type_id, gif_url: this.props.gifPreview[0].image })
        }
    }

    onRequestClose = (closeManually = false) => {
        gtmSend('post_compose', 'Post', 'Compose', 'Close', 0, { action: 'Close' });
        if (this.props.isCompose && closeManually) {
            this.resetState();
            this.setState({ isModalOpen: false });
            if(this.props.eventHandlers.onModalCloseGetStateValue) this.props.eventHandlers.onModalCloseGetStateValue(this.state)
            if (this.props.eventHandlers.onModalClose) this.props.eventHandlers.onModalClose(true);
        } else if (!this.props.isCompose) {
            this.resetState();
            this.setState({ isModalOpen: false });
            if(this.props.eventHandlers.onModalCloseGetStateValue) this.props.eventHandlers.onModalCloseGetStateValue(this.state)
            if (this.props.eventHandlers.onModalClose) this.props.eventHandlers.onModalClose(true);
        }
    }

    openTooltip = () => {
        const tooltip = document.querySelector('.tooltip');
        const gimBody = document.querySelector('.gim-body');
        if (!this.state.openTooltip && !this.state.showGIF) {
            tooltip.classList.add('active');
            gimBody.classList.add('dynamic');
            this.setState({ openTooltip: true, showHashtag: false });
        } else {
            tooltip.classList.remove('active');
            gimBody.classList.remove('dynamic');
            this.setState({ openTooltip: false });
        }
    }

    checkAttachments = () => {
        if ((this.props.imagePreviews && this.props.imagePreviews.length !== 0) || (this.props.linkPreview && this.props.linkPreview.url) || (this.state.gif_url && this.state.gif_url.length > 0)) {
            this.openPreview('upload')
        }
    }

    openPreview = (section) => {
        const previewSection = document.querySelector('.more-details-preview');
        if (!this.state.opnePreviewSection && previewSection) {
            previewSection.classList.add('active-preview');
            this.setState({ opnePreviewSection: true, showHashtag: false });
        } else if (this.state.opnePreviewSection && section === 'dropdown' && previewSection) {
            previewSection.classList.remove('active-preview');
            this.setState({ opnePreviewSection: false, showHashtag: false });
        }
    }

    changeBtnColor = () => {
        const title = document.querySelector('.title');
        const desc = document.getElementById('content')
        const btn = document.querySelector('.post')
        if (btn) {
            if (title && title.value && title.value.length >= 10 && desc && desc.value && desc.value.length >= 10) {
                btn.classList.add('blue-btn')
            } else {
                btn.classList.remove('blue-btn')
            }
        }
    }

    toggleEmbedLink = () => {
        this.setState({ showEmbed: !this.state.showEmbed })
    }

    setSelectedTopic = (groupId, groupName, groupImage) => {
        this.setState({ groupId: groupId, groupName: groupName, groupImage: groupImage });
    }

    setLoading = (loading) => {
        this.setState({ loading: loading })
    }

    titleChange = (e) => {
        let inputValue = e.target.value;
        if (inputValue.length > 100) {
            inputValue = e.target.value.substring(0, 100);
        }
        this.props.eventHandlers.onTitleChange(inputValue)
    }

    adjustDesc = () => {
        const desc = document.getElementById('content');
        desc.style.height = `${desc.scrollHeight}px`
    }

    contentChange = (e) => {
        const desc = document.getElementById('content');
        desc.style.height = 'auto'
        this.props.eventHandlers.onContentChange(e.target.value)
    }

    autosize = () => {
        document.getElementById('content').parentNode.dataset.value = document.getElementById('content').value
    }

    showGIFPreview = () => {
        this.setState({ showGIF: true })
        this.state.openTooltip ? this.openTooltip() : '';
    }

    handleGIFSelect = (gifId, gifURL) => {
        this.setState({ showGIF: false, gif_id: gifId, gif_url: gifURL })
    }

    handleGIFToggle = () => {
        this.setState({ showGIF: false })
    }

    toggleSimilarScreen = () => {
        this.setState({ showSimilarQues: false })
    }

    readPostFromDb = () => {
        const request = indexedDB.open('questionDraft', 1);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
    
            const store = db.createObjectStore(`post`, {
                autoIncrement: true
            });
    
            store.createIndex(`userId`, `userId`, {
                unique: true
            });
        };

        request.onerror = (event) => {
            console.error(`Database error: ${event.target.errorCode}`);
        };

        request.onsuccess = (event) => {
            if(!this.props.user.id) {
                return;
            } 
            
            this.readPost(event.target.result, `post`, `readonly`, this.props.user.id, `userId`);
        }
    }

    readPost = (db, dbObject, transactionMode = `readonly`, id, indexValue) => {
        // const that = this;
        const txn = db.transaction(dbObject, transactionMode);
        const store = txn.objectStore(dbObject);

        const index = store.index(indexValue);

        const query = index.get(id);

        query.onsuccess = () => {

            const result = query.result;
            if(result) {
              this.setState(
                { 
                    groupId: result.groupId, 
                    groupName: result.groupName, 
                    groupImage: result.groupImage 
                });
            } else {
                this.selectTopic();
            }
        };

        query.onerror = () => {
            return {}
        }

        txn.oncomplete = function () {
            db.close();
        };
    }
    Stage1 = () => {
        const { title, content, imagePreviews, user, linkPreview = null, showUploadInput = false, showUploadGif = false, showUploadEmbed = false, showNSFW = false, showAnonymous = true, isCompose = false, isPoll = false, isReply = false, isComment = false, ifEditing = false, contentPlaceholder = '', t, isMemory = false } = this.props;
        const { onImageUpload, onPreviewImageRemove, onLinkPreviewRemove, onHashClick } = this.props.eventHandlers;
        const { onSubmit, onGifRemove } = this.props.eventHandlers;

        return (
            <div className={cx('stage1')}>
                <div className="gim-head">
                    <div className={cx("left")}>
                        <ProfileThumb img={user.image && !this.state.anonymous ? user.image : ""} altName={`${user.fullname} profile icon`} />

                        <div>
                            <p>{!this.state.anonymous ? user.fullname : t('add_anonymous')}</p>
                            {
                                showAnonymous && !(ifEditing || isMemory) &&
                                <div className={cx("btn-check-label")}>
                                    <input id="anonymous-input" checked={this.state.anonymous} onChange={e => { this.setState({ anonymous: +e.target.checked }); this.setState({ showHashtag: false }); }} type="checkbox" />
                                    <label htmlFor="anonymous-input" className={cx("pointer-click")}>{t('post_anonymously')}</label>
                                </div>
                            }
                        </div>
                    </div>


                    <div className={cx("right")}>
                        <span className={cx("info-icon")} onClick={() => this.openTooltip()}>
                            <Icon name="info-icon-regular" />
                        </span>
                        <span className={cx("close-modal")} onClick={(/*e*/) => this.onRequestClose(true)} >
                            <Icon name="cross-regular-dark-smd" />
                        </span>
                    </div>
                </div>

                <form onSubmit={onSubmit}>
                    <div className={cx("gim-body", isComment ? "comment-body" : "")}>
                        <div className="input-wrap">
                            <div>

                                {
                                    (isCompose || ifEditing) && !isReply && !isPoll &&
                                    <div className={cx('text-wrap')}>
                                        <div className={cx('input-wrap')}>
                                            <input type="text" className={cx('title')} placeholder={t('post_title')} name="title" autoFocus={mobileCheck() ? false : true} minLength="10"
                                                onKeyUp={this.changeBtnColor()} value={title} onClick={() => { gtmSend('post_compose', 'Post', 'Compose', 'Title', 0, { action: 'Title' }); this.state.openTooltip ? this.openTooltip() : ''; this.setState({ showHashtag: false }) }} onChange={e => this.titleChange(e)} />
                                            <div className={cx('letter-wrap')}>
                                                <span className={cx('letter-count')}>{100 - title.length}</span>
                                            </div>
                                        </div>
                                        {
                                            (title.length > 9 || content.length > 9) &&
                                            <div className={cx('similar-questions')} onClick={() => { this.setState({ showSimilarQues: true, showHashtag: false }); gtmSend('post_compose', 'Post', 'Compose', 'View Similar Questions', 0, { action: 'View Similar Questions' }); }}>{t('view_similar_question')}</div>
                                        }
                                    </div>
                                }

                                <SimilarQuestions
                                    showSimilarQues={this.state.showSimilarQues}
                                    toggleSimilarScreen={this.toggleSimilarScreen}
                                    title={title}
                                    content={content}
                                    setLoading={this.setLoading}
                                />

                                <div className={cx("desc-wrap")}>
                                    <label className={cx("description stacked")}>
                                        <textarea onInput={this.autosize}
                                            id='content' rows="1" minLength="10"
                                            name="content" value={content} placeholder={contentPlaceholder}
                                            autoFocus={!mobileCheck() && !isCompose ? true : false}
                                            onChange={e => this.contentChange(e)}
                                            onKeyUp={this.changeBtnColor()}
                                            onFocus={() => this.setState({ showHashtag: true })}
                                            onClick={() => { gtmSend('post_compose', 'Post', 'Compose', 'Description', 0, { action: 'Description' }); this.state.openTooltip ? this.openTooltip() : ''; }}
                                        />
                                    </label>
                                </div>

                                {
                                    showUploadInput &&
                                    <div className={cx("only-mobile", "upload-mobile-btn")} >
                                        <label htmlFor="file-input-mobile" className={cx("bg-img")}><Icon name="camera-regular-gray-md" /></label>
                                        <input id="file-input-mobile" name="image" type="file" onChange={onImageUpload} multiple />
                                    </div>
                                }

                                <div className={cx('more-details-preview')}>
                                    <div className={cx('more-details-section')} onClick={() => this.openPreview('dropdown')}>
                                        <div className={cx('more-details')}>
                                            {t('more_details')}
                                        </div>
                                        <div className={cx('dropdown-icon')}>
                                            <span className={cx('right-arrow')}><Icon name="right-arrow-regular" /></span>
                                            <span className={cx('down-arrow')}><Icon name="down-arrow-regular" /></span>
                                        </div>
                                    </div>
                                    <div className={cx('preview-section')}>
                                        {
                                            imagePreviews.length == 0 && linkPreview && !linkPreview.url && !this.state.gif_url &&
                                            <div>
                                                <div className={cx('upload-section')}>
                                                    {
                                                        showUploadInput &&
                                                        <div className={cx('upload-wrap')}>
                                                            <label htmlFor="file-input" onClick={() => { gtmSend('post_compose', 'Post', 'Compose', 'More Details - Upload Image/ Video', 0, { action: 'More Details - Upload Image/ Video' }); }}>
                                                                <div className={cx('upload-icon')}>
                                                                    <Icon name="black-camera-regular" />
                                                                </div>
                                                                <p className={cx('upload-text upload-image')}>{t('upload_image')}</p>
                                                            </label>
                                                            <input id="file-input" name="image" type="file" onChange={onImageUpload} multiple onClick={() => { gtmSend(`${this.props.gtmLabel == 'Reply Input' ? 'cw_reply_compose' : 'cw_post_compose'}`, `${this.props.cardName ? this.props.cardName : 'Post'}`, `${this.props.gtmLabel == 'Reply Input' ? 'Reply Compose' : `${this.props.gtmLabel == 'Booth Comment Compose' ? 'Reply Compose' : 'Compose'}`}`, 'Add Photo', 0, this.props.cardName && this.props.topic ? { card_type: this.props.cardName, card_id: this.props.id, topic_id: this.props.topic.id } : {}); this.handleGIFToggle(); }} />
                                                        </div>
                                                    }
                                                    {
                                                        showUploadGif &&
                                                        <div className={cx('upload-wrap')} onClick={() => { this.showGIFPreview(); this.setState({ showHashtag: false }); gtmSend('post_compose', 'Post', 'Compose', 'More Details - Upload GIF', 0, { action: 'More Details - Upload GIF' }); }}>
                                                            <div className={cx('upload-icon')}>
                                                                <Icon name="black-gif-regular" />
                                                            </div>
                                                            <p className={cx('upload-text')}>{t('upload_gif')}</p>
                                                        </div>
                                                    }
                                                    {
                                                        showUploadEmbed &&
                                                        <div className={cx('upload-wrap')} onClick={() => { this.setState({ showEmbed: true, showHashtag: false }); this.handleGIFToggle(); gtmSend('post_compose', 'Post', 'Compose', 'More Details - Embed URL', 0, { action: 'More Details - Embed URL' }); }}>
                                                            <div className={cx('upload-icon')}>
                                                                <Icon name="black-url-regular" />
                                                            </div>
                                                            <p className={cx('upload-text')}>{t('embed_URL')}</p>
                                                        </div>
                                                    }
                                                </div>
                                                <p className={cx('note')}>
                                                    {t('note')}
                                                </p>
                                            </div>
                                        }

                                        {
                                            imagePreviews.length !== 0 &&
                                            <div className={cx("uploaded-img-wrap")}>
                                                {
                                                    imagePreviews.map((src, i) => {
                                                        return (
                                                            <div className={cx("uploaded-img", this.state.isNSFWChecked ? "nsfw-img" : "")} key={i}>
                                                                <div className={cx("bg-img")} style={{ backgroundImage: `url(${src})` }}></div>
                                                                <span className={cx("close")} onClick={() => onPreviewImageRemove(i)}>
                                                                    <Icon name={"close-regular-black-sm"} />
                                                                </span>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        }

                                        {
                                            this.state.gif_url.length > 0 &&
                                            <div className={cx("uploaded-img-wrap gif")}>
                                                <div className={cx("uploaded-img")}>
                                                    <div className={cx("bg-img")} style={{ backgroundImage: `url(${this.state.gif_url})` }}></div>
                                                    <span className={cx("close")} onClick={() => {if(onGifRemove) onGifRemove(); this.setState({ gif_url: '', gif_id: '' })}}>
                                                        <Icon name={"close-regular-black-sm"} />
                                                    </span>
                                                </div>
                                            </div>
                                        }

                                        {
                                            showNSFW && !!imagePreviews.length &&
                                            <div className={cx("btn-check-label", "not-safe", 'check-box')}>
                                                <input id="nsfw-desktop" type="checkbox" name="nsfw" checked={this.state.isNSFWChecked} onChange={e => { this.setState({ isNSFWChecked: +e.target.checked }); }} />
                                                <label htmlFor="nsfw-desktop" className={cx("pointer-click")}>{t('nsfw_images_msg')}</label>
                                            </div>
                                        }

                                        {
                                            linkPreview && linkPreview.url &&
                                            <div className="article-preview-wrap">
                                                <div className={cx("article-link-preview-horizontal")} >
                                                    <div className={cx("bg-img")} style={{ backgroundImage: `url(${linkPreview.linkData.thumbnail})` }}></div>
                                                    <div>
                                                        <h2><a href={linkPreview.linkData.url} rel="nofollow">{linkPreview.linkData.title}</a></h2>
                                                        <p>{linkPreview.linkData.description}</p>
                                                    </div>
                                                </div>
                                                {
                                                    showUploadEmbed &&
                                                    <span className={cx("close")} onClick={onLinkPreviewRemove}>
                                                        <Icon name={"close-regular-black-sm"} />
                                                    </span>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className={cx('border-bottom')}></div>
                                {
                                    this.state.groupName &&
                                    <SelectTopic
                                        groupName={this.state.groupName}
                                        groupImage={this.state.groupImage}
                                        groupId={this.state.groupId}
                                        setSelectedTopic={this.setSelectedTopic}
                                        topic={this.props.topic}
                                        addNotification={this._addNotification}
                                        content={content}
                                        setLoading={this.setLoading} />
                                }
                            </div>
                        </div>
                    </div>

                    <div className={cx('bottom-section')}>
                        <div className={cx("tooltip")}>
                            <div className={cx("tooltip-wrap")}>
                                <div className={cx("tooltip-icon")}>
                                    <Icon name={"bulb-tooltip-regular"} />
                                </div>
                                <div className={cx("tooltip-content")}>
                                    <p className={cx("tooltip-title")}>
                                        {t('tooltip_title')}
                                    </p>
                                    <p className={cx("tooltip-text")}>
                                        {t('tooltip_message')}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <EmbedLink
                            showEmbed={this.state.showEmbed}
                            toggleEmbedLink={this.toggleEmbedLink}
                            linkPreview={this.props.composeReducer.linkPreview}
                            imagePreviews={this.props.imagePreviews}
                            setLoading={this.setLoading}
                            addNotificationMessage={this._addNotificationMessage}
                        />

                        <FetchGIF
                            showGIF={this.state.showGIF}
                            handleSelect={this.handleGIFSelect}
                            handleGIFToggle={this.handleGIFToggle}
                        />

                        <Hashtags
                            showHashtag={this.state.showHashtag}
                            onHashClick={onHashClick}
                        />

                        <div className={cx("gim-bottom")}>
                            {
                                imagePreviews.length <= 4 && !linkPreview.url &&
                                <div className={cx("left")}>
                                    {
                                        showUploadInput && !this.state.gif_url && linkPreview && !linkPreview.url &&
                                        <div className={cx("btn-image-upload")} onClick={() => { this.handleGIFToggle(); this.setState({ showHashtag: false }); gtmSend('post_compose', 'Post', 'Compose', 'Upload Image/ Video', 0, { action: 'Upload Image/ Video' }); }}>
                                            <label htmlFor="file-input">
                                                <Icon name={"blue-camera-regular"} />
                                            </label>
                                            <input id="file-input" name="image" type="file" onChange={onImageUpload} multiple />
                                        </div>
                                    }

                                    {
                                        showUploadGif && imagePreviews.length == 0 && linkPreview && !linkPreview.url && !this.state.gif_url &&
                                        <div className={cx("btn-gif-upload")} onClick={() => { this.showGIFPreview(); this.setState({ showHashtag: false }); gtmSend('post_compose', 'Post', 'Compose', 'Upload GIF', 0, { action: 'Upload GIF' }); }}>
                                            <Icon name={"blue-gif-regular"} />
                                        </div>
                                    }

                                    {
                                        showUploadEmbed && imagePreviews.length == 0 && !this.state.gif_url &&
                                        <div className={cx("btn-url-upload")} onClick={() => { this.setState({ showEmbed: true, showHashtag: false }); this.handleGIFToggle(); gtmSend('post_compose', 'Post', 'Compose', 'Embed URL', 0, { action: 'Embed URL' }); }}>
                                            <Icon name={"blue-url-regular"} />
                                        </div>
                                    }

                                </div>
                            }
                            <div className={cx("right")}>
                                {this.state.gif_id.length > 0 && <input type="hidden" name="gifId" value={this.state.gif_id} />}
                                <input type="hidden" name="anonymous" value={this.state.anonymous} />

                                <input type="hidden" name="groupId" value={this.state.groupId} />
                                <input className={cx("btn", "btn-primary", "active", "post")} type="submit" value={t('add_send')} />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    render() {
        const Stage1 = this.Stage1;
        return (
            <Fragment>
                {this.state.loading && <Loader />}
                <Modal isOpen={this.props.isModalOpen}
                    onAfterOpen={this.onAfterOpen}
                    onRequestClose={this.onRequestClose}
                    overlayClassName={this.props.isComment ? "myOverlayClass generic-input-modal-overlay comment-modal-overlay" : "myOverlayClass generic-input-modal-overlay"}
                    style={typeof this.props.style !== 'undefined' ? this.props.style : customStyles}>

                    <div className={cx("generic-input-modal")}>
                        <NotificationSystem ref={n => this._notificationSystem = n} />
                        <Stage1 />
                    </div>
                </Modal>
            </Fragment>
        );
    }
}
//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        topicListFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(GenericInputModal));
